import React from "react";
import { useTranslation } from "react-i18next";
import { Divider, Stack } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import Button from "components/basic/button";

interface VendorActionsProps {
  onEdit?: () => void;
  onDelete?: () => void;
}

const VendorActions: React.FC<VendorActionsProps> = ({ onEdit, onDelete }) => {
  const { t } = useTranslation("calendar");

  return (
    <>
      <Divider sx={{ my: 2 }} />
      <Stack spacing={1}>
        <Button
          variant="outlined"
          color="primary"
          fullWidth
          startAdornment={<EditOutlinedIcon fontSize="small" />}
          onClick={onEdit}
        >
          {t("details.edit_event")}
        </Button>
        <Button
          variant="outlined"
          color="error"
          fullWidth
          startAdornment={<DeleteOutlineIcon fontSize="small" />}
          onClick={onDelete}
        >
          {t("details.delete_event")}
        </Button>
      </Stack>
    </>
  );
};

export default VendorActions;
